import React from "react"
import styled from "styled-components"

const DetailTable = ({ testArray, formatNumberWithCommas }) => {
  return (
    <Container>
      <table>
        <thead>
          <tr>
            <th>Age</th>
            <th>Salary</th>
            <th>Savings</th>
            <th>Interest</th>
            <th>Retirement</th>
          </tr>
        </thead>
        <tbody>
          {testArray.map((item, index) => {
            return (
              <tr key={index}>
                <td>{item.currentAge}</td>
                <td>{formatNumberWithCommas(item.currentSalary)}</td>
                <td>{formatNumberWithCommas(item.currentSavings)}</td>
                <td>{formatNumberWithCommas(item.currentInterest)}</td>
                <td>{formatNumberWithCommas(item.newRetirementFund)}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </Container>
  )
}

export default DetailTable

const Container = styled.div`
  /* background: lightseagreen; */
  margin-top: 10px;

  @media screen and (min-width: 1000px) {
    margin-left: 5vw;
    margin-top: 0;
  }

  table {
    background-color: #e2f6ed;
    margin: 10px 0;
    overflow-y: hidden;

    th {
      padding: 10px 3vw;

      @media screen and (min-width: 1000px) {
        padding: 10px 1.5vw;
      }
    }

    tbody {
      text-align: center;
    }

    td {
      animation: rise 0.5s;
    }

    @keyframes rise {
      100% {
        transform: translateY(0px);
      }
      0% {
        transform: translateY(20px);
      }
    }
  }
`
